import axios from "axios";
import { showToast } from "../components/Toasts";
import { showGlobalWaitIndicator } from "../components/GlobalWaitIndicator";
import { isBetaVersion } from "../uiMode";
import { isDevelopmentEnvironment } from "../estada-config";

// Ionos backend urls:
export const AppIonosUrl = "https://backendapp.estada.de"; // no itx
export const BetaIonosUrl = "https://backendbeta.estada.de"; // no itx
export const DevIonosUrl = "https://backenddev.estada.de"; // no itx

// Localhost urls:
export const LocalBackendUrl = "http://localhost:4000"; // no itx
export const LocalEtsAppUrl = "http://localhost:1234"; // no itx

// Deprecated: Azure backend urls
export const AppAzureUrl = "https://estada.azurewebsites.net"; // no itx
export const BetaAzureUrl = "https://estada-beta.azurewebsites.net"; // no itx

// Change this for testing:
const _httpBaseUrl = AppIonosUrl;

export const getBaseUrl = () => {
  // mwe 12.3.2026
  // notfalls zugriff auf ionos server wegen login problemen mit azure

  // return LocalBackendUrl; // debugging with local backend

  // Active Ionos backend server
  // Instruction: Uncomment the next 4 lines to run the app against backenddev or localhost server
  // if (isDevelopmentEnvironment()) {
  //   return DevIonosUrl;
  //   // return LocalBackendUrl;
  // } else
  if (isBetaVersion()) {
    return BetaIonosUrl;
  } else {
    return AppIonosUrl;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  // Deprecated: azure backend urls
  if (isBetaVersion()) {
    return BetaAzureUrl;
  } else {
    return AppAzureUrl;
  }
};

// const axiosInstance = axios.create({ timeout: 30000 });
const axiosInstance = axios.create();
axiosInstance.defaults.baseURL = getBaseUrl();

// request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Do before sending request
    if (!state.dialogManager.isOpen && !noLoaderAPIs(config) && state.showLoader) {
      showLoader();
    }
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token; // no itx
    }
    // config.headers['Content-Type'] = 'application/json';
    return config;
  },
  (error) => {
    // If request error
    showNotificationIfUserOffline();
    Promise.reject(error);
  },
);

// Response Interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // Response Status Code 2xx
    hideLoader();
    return response;
  },
  (error) => {
    // Other Status Codes
    console.error("axios error", error);
    if (error.code == "ECONNABORTED") {
      showToast({
        isError: true,
        text: state.translate("axios.interruptedServerConnection", "Serververbindung unterbrochen"),
      });
    }

    hideLoader();
    showNotificationIfUserOffline();
    return Promise.reject((error.response && error.response?.data) || "Something went wrong");
  },
);

function noLoaderAPIs(config: any) {
  return (
    config.url?.startsWith("/api/projectexport/checkProjectData") ||
    config.url?.startsWith("/api/projectexport/downloadProjectData") ||
    config.url?.startsWith("/api/projectexport/uploadXchangeData") ||
    config.url?.startsWith("/api/uploadProductData") ||
    config.url?.startsWith("/api/uploadImage") ||
    config.url?.startsWith("/api/listProductData") ||
    config.url?.startsWith("/api/lookupVoltusDatafeedRow") ||
    config.url?.startsWith("/api/downloadVoltusDatafeedCSV") ||
    config.url?.startsWith("/api/orderFolderGitlabAssets") ||
    config.url?.startsWith("/api/uploadOrderFileToGitlab") ||
    config.url?.startsWith("/api/uploadConfigScriptToGitlab") ||
    config.url?.startsWith("/api/uploadAllSignalsToGitlab") ||
    config.url?.startsWith("/api/orderFolderGitlabFile") ||
    config.url?.startsWith("/api/scriptWizard/") ||
    config.url?.startsWith("/api/getBackofficeStatus") ||
    config.url?.startsWith("/api/project") ||
    config.url?.endsWith("/api/project") ||
    config.url?.endsWith("/api/updateUser")
  );
}

export async function etsFetch(url: any, options: any): Promise<any> {
  return new Promise((resolve) => {
    fetch(url, options)
      .then((res) => resolve(res))
      .catch(() => {
        resolve({ ok: false });
      });
  });
}

export const fetchWithTimeout = (url: any, options: any, timeout = 900000) => {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error("Request timed out")); // no itx
    }, timeout);

    fetch(url, options)
      .then((response) => {
        clearTimeout(timer);
        resolve(response);
      })
      .catch((err) => {
        clearTimeout(timer);
        reject(err);
      });
  });
};

export const Timeout = (time: number) => {
  const controller = new AbortController();
  setTimeout(() => controller.abort(), time * 1000);
  return controller;
};

export function redirectToLogin() {
  state.navigate("/login");
  // window.location.href = "/login";
}

export function showNotificationIfUserOffline() {
  if (!navigator.onLine) {
    showToast({
      isError: true,
      text: state.translate(
        "axios.checkInternet",
        "Die Verbindung zum Server kann nicht hergestellt werden. Bitte überprüfen Sie Ihr Internet",
      ),
    });
  }
}

export function showLoader() {
  showGlobalWaitIndicator(true);
}

export function hideLoader() {
  showGlobalWaitIndicator(false, "", true);
}

export default axiosInstance;
